import { AppBarStickyState, PageRegion } from 'page-context/scrollStickyStateProvider/stickybar-types.js';

export const getSearchBarColor = (
  isOneCol: boolean,
  searchBarState: AppBarStickyState | undefined,
): 'blue' | 'white' => {
  if (searchBarState?.region === PageRegion.primary) {
    return 'blue';
  }
  if (isOneCol) {
    return 'blue';
  }

  return 'white';
};

export const getSearchBarFill = (
  hasSecondaryNavigration: boolean,
  searchBarState: AppBarStickyState | undefined,
): string => {
  // const hasSecondaryNavBar = Boolean(navigation?.links?.length);

  if (hasSecondaryNavigration && searchBarState?.region === PageRegion.primary) {
    return 'solid';
  }
  return 'gradient';
};
